import React from 'react';
import PropTypes from 'prop-types';
import { EditorView } from 'prosemirror-view';

import LinkInput from '../../link/components/LinkInput';

import toolbarStyles from './ImageToolbar.module.scss';

const propTypes = {

	/**
	 * The prosemirror editor view object.
	 */
	editorView: PropTypes.instanceOf(EditorView).isRequired,

	/**
	 * The URL of the selected linked image.
	 */
	href: PropTypes.string,

	/**
	 * Callback for handling 'back' button click.
	 */
	onBack: PropTypes.func.isRequired,

};

const ImageLink = ({ editorView, href, onBack }) => {

	return (
		<div className="d-flex">
			<span
				className={`pr-2 ${toolbarStyles['icon-btn']}`}
				onClick={onBack}>
				<i className="fas fa-arrow-left" />
			</span>
			<LinkInput
				editorView={editorView}
				href={href}
				dividerClass={toolbarStyles.divider}
				buttonClass={toolbarStyles['icon-btn']}
				onRemove={onBack} />
		</div>
	);

};

ImageLink.propTypes = propTypes;

export default ImageLink;
